module.exports = __webpack_public_path__ + "static/img/cont502.afa5d9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont502.jpg
// module id = RH4G
// module chunks = 0